class MusicManager {
  constructor() {
    this.popSrc = require("./../assets/pop-short.mov");
    this.snareSrc = require("./../assets/snare-short.mov");
    this.trumpetSrc = require("./../assets/trumpet.mp3");

    //new
    this.kahootlobby = require("./../assets/kahoot-lobby-music.mp3");//kahoot-lobby-music.mp3
    this.warmupAudio = null; // keep a reference so we can stop it

    this.encouragements = [
      "Nice jump!",
      "Feel your abs burning!",
      "Keep pushing!",
      "You got this!",
      "You're on fire!",
      "Keep going!"
    ];
    //"Team power! Both of you hit 20 reps!"
    //"You made the leaderboard. Way to go!"
  }

  playPop() {
    const audio = new window.Audio(this.popSrc);
    audio.play();
  }

  playSnare() {
    const audio = new window.Audio(this.snareSrc);
    audio.play();
  }

  playTrumpet() {
    const audio = new window.Audio(this.trumpetSrc);
    audio.play();
  }

  //new
  playWarmup() {
    if (this.warmupAudio) return; // already playing
    const audio = new window.Audio(this.kahootlobby);
    audio.loop = true;

    audio
    .play()
    .then(() => {
      // Only store it after play() actually succeeds
      this.warmupAudio = audio;
    })
    .catch((err) => {
      // Autoplay might be blocked or interrupted – safe to ignore for now
      console.warn("Warmup audio could not be played:", err);
    });
  }
  stopWarmup() {
    if (this.warmupAudio) {
      this.warmupAudio.pause();
      this.warmupAudio.currentTime = 0;
      this.warmupAudio = null;
    }
  }

  sayText(text) {
    if ("speechSynthesis" in window) {
      const utterance = new window.SpeechSynthesisUtterance(text);
      window.speechSynthesis.speak(utterance);
    } else {
      console.warn("Text-to-speech not supported in this browser");
    }
  }
  
  sayRandomEncouragement() {
    const list = this.encouragements;
    const idx = Math.floor(Math.random() * list.length);
    this.sayText(list[idx]);
  }
}

export const musicManager = new MusicManager();
